import { Button } from "./Button";
import { FlexibleTitle } from "./FlexibleTitle";

export function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero__content">
        <FlexibleTitle />
        <p>
          Self-learning AI for automating repetitive engineering tasks.
        </p>
        <div className="hero__actions" aria-label="Primary actions">
          <Button
            href="#contact"
            tone="ghost"
            className="button--hero"
            onClick={() => {
              window.dispatchEvent(new CustomEvent("spaceport:open-waitlist"));
            }}
          >
            Contact
          </Button>
        </div>
      </div>
    </section>
  );
}
